module.exports = __webpack_public_path__ + "static/media/grande_partenza.9716a6ea.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/grande_partenza.mp3
// module id = 187
// module chunks = 0